import { makeStyles } from "@material-ui/core/styles";
import { colors } from "~/utils/colors";

const { background } = colors;

export default makeStyles((theme, props) => ({
    "@keyframes slideUp": {
    from: {
      transform: "translateY(70vh)",
      opacity: 0,
    },
    to: {
      transform: "translateY(0)",
      opacity: 1,
    },
  },

  "@keyframes slideRight": {
    from: {
      transform: "translateX(100vw)",
      opacity: 0,
    },
    to: {
      transform: "translateX(0)",
      opacity: 1,
    },
  },

  container: {
      position: "absolute",
      width: "100%",                
      maxWidth: 480,                
      left: 0,                      
      right: 0, 
      margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      padding: 20,
      borderTopLeftRadius: 30,
      borderTopRightRadius: 30,
      boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.2)",
      backgroundColor: background?.default,
      
      animation: `$slideUp 0.6s ease-out`
  },

  containerSlideRight: {
    animation: `$slideRight 0.6s ease-out`,
  },

  containerChildren: ({ height, activeButton }) => ({
    minHeight: `calc(${height} + 130px)`,
    height: 'auto',
    paddingBottom: activeButton ? 150 : 50
}),

  title: {
    fontWeight: "bold",
    color: "#474747",
    marginLeft: "12px",
    fontSize: "20px",
    marginBottom: 10
  },

  fixedButton: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    background: "#FDFCF8", 
    padding: 8,
    boxShadow: "0px -2px 8px rgba(0,0,0,0.08)"
  },
}));
